import { render, staticRenderFns } from "./Tooltip.vue?vue&type=template&id=5846524c&scoped=true"
import script from "./Tooltip.vue?vue&type=script&lang=js"
export * from "./Tooltip.vue?vue&type=script&lang=js"
import style0 from "./Tooltip.vue?vue&type=style&index=0&id=5846524c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5846524c",
  null
  
)

export default component.exports